import AddBatch from "../component/Pages/Batch/AddBatch/AddBatch";
import EditBatch from "../component/Pages/Batch/EditBatch/EditBatch";
import Batch from "../component/Pages/Batch/ViewBatch/Batch";
import AddCourses from "../component/Pages/Courses/AddCourses/AddCourses";
import EditCourses from "../component/Pages/Courses/EditCourses/EditCourses";
import Courses from "../component/Pages/Courses/ViewCourses/Courses";
import Center from "../component/Pages/Center/ViewCenter/Center";
import AddCenter from "../component/Pages/Center/AddCenter/AddCenter";
import EditCenter from "../component/Pages/Center/EditCenter/EditCenter";
import Dashboard from "../component/Pages/Dashboard/DashboardView/Dashboard";

import Subject from "../component/Pages/Subject/ViewSubject/Subject";
import AddSubject from "../component/Pages/Subject/AddSubject/AddSubject";
import EditSubject from "../component/Pages/Subject/EditSubject/EditSubject";

import Section from "../component/Pages/Section/ViewSection/Section";
import AddSection from "../component/Pages/Section/AddSection/AddSection";
import EditSection from "../component/Pages/Section/EditSection/EditSection";

import Slot from "../component/Pages/Slot/ViewSlot/Slot";
import AddSlot from "../component/Pages/Slot/AddSlot/AddSlot";
import EditSlot from "../component/Pages/Slot/EditSlot/EditSlot";

import GenerateRegistrationLink from "../component/Pages/GenerateRegistrationLink/ViewGenerateRegistrationLink/GenerateRegistrationLink";
import ViewTotalApplication from "../component/Pages/GenerateRegistrationLink/ViewGenerateRegistrationLink/TotalApplication";
import AddGenerateRegistrationLink from "../component/Pages/GenerateRegistrationLink/AddGenerateRegistrationLink/AddGenerateRegistrationLink";
import EditGenerateRegistrationLink from "../component/Pages/GenerateRegistrationLink/EditGenerateRegistrationLink/EditGenerateRegistrationLink";

import Learner from "../component/Pages/Learner/ViewLearner/Learner";
import AddLearner from "../component/Pages/Learner/AddLearner/AddLearner";
import EditLearner from "../component/Pages/Learner/EditLearner/EditLearner";
import AssignLearner from "../component/Pages/Learner/AssignLearner/AssignLearner";
import Exam from "../component/Pages/Exam/ViewExam/Exam";
import AddExam from "../component/Pages/Exam/AddExam/AddExam";
import EditExam from "../component/Pages/Exam/EditExam/EditExam";
import ExamDashboard from "../component/Pages/Exam/ExamDashboard/ExamDashboard";
import ExamResult from "../component/Pages/Exam/ExamResult/ExamResult";
import AddQuestionMain from "../component/Pages/Exam/AddQuestion/AddQuestionMain";

import AddMarksMain from "../component/Pages/Exam/AddMarks/AddMarksMain";

import AddMarkingSystem from "../component/Pages/MarkingSystem/AddCourses/AddMarking";
import EditMarkingSystem from "../component/Pages/MarkingSystem/EditCourses/EditMarkings";
import MarkingSystem from "../component/Pages/MarkingSystem/ViewCourses/MarkingList";
// import MarkingSystem from "../component/Pages/MarkingSystem/Index";

import ViewOMR from '../component/Pages/OMR/ViewOMR/OMR';
import AddOMR from '../component/Pages/OMR/AddOMR/AddOMR';
import ScoreScheme from "../component/Pages/ScoreScheme/ViewScoreScheme/ScoreScheme";
import AddScoreScheme from "../component/Pages/ScoreScheme/AddAddScoreScheme/AddAddScoreScheme";
import EditScoreScheme from "../component/Pages/ScoreScheme/EditScoreScheme/EditScoreScheme";

const BasicSixMonths = [
  {
    id: "dashboard",
    path: "/admin/dashboard",
    element: <Dashboard />,
  },
  {
    id: "center",
    path: "/admin/center",
    element: <Center />,
  },
  {
    id: "addcenter",
    path: "/admin/addcenter",
    element: <AddCenter />,
  },
  {
    id: "editcenter",
    path: "/admin/editcenter/:rowId",
    element: <EditCenter />,
  },
  {
    id: "courses",
    path: "/admin/courses",
    element: <Courses />,
  },
  {
    id: "addcourses",
    path: "/admin/addcourses",
    element: <AddCourses />,
  },
  {
    id: "editcource",
    path: "/admin/editcource/:rowId",
    element: <EditCourses />,
  },
  {
    id: "marking",
    path: "/admin/markingSystem",
    element: <MarkingSystem />,
  },
  {
    id: "addmarking",
    path: "/admin/addMarkingSystem",
    element: <AddMarkingSystem />,
  },
  {
    id: "editmarking",
    path: "/admin/editMarkingSystem/:rowId",
    element: <EditMarkingSystem />,
  },
  {
    id: "batch",
    path: "/admin/batch",
    element: <Batch />,
  },
  {
    id: "addbatch",
    path: "/admin/addbatch",
    element: <AddBatch />,
  },
  {
    id: "editbatch",
    path: "/admin/editbatch/:rowId",
    element: <EditBatch />,
  },
  {
    id: "subject",
    path: "/admin/subject",
    element: <Subject />,
  },
  {
    id: "addsubject",
    path: "/admin/addsubject",
    element: <AddSubject />,
  },
  {
    id: "editsubject",
    path: "/admin/editsubject/:rowId",
    element: <EditSubject />,
  },

  {
    id: "section",
    path: "/admin/section",
    element: <Section />,
  },
  {
    id: "addsection",
    path: "/admin/addsection",
    element: <AddSection />,
  },

  {
    id: "editsection",
    path: "/admin/editsection/:rowId",
    element: <EditSection />,
  },

  {
    id: "slot",
    path: "/admin/slot",
    element: <Slot />,
  },
  {
    id: "addslot",
    path: "/admin/addslot",
    element: <AddSlot />,
  },

  {
    id: "editslot",
    path: "/admin/editslot/:rowId",
    element: <EditSlot />,
  },

  {
    id: "registrationlink",
    path: "/admin/registrationlink",
    element: <GenerateRegistrationLink />,
  },

  {
    id: "viewtotalapplication",
    // path: "/admin/viewtotalapplication",
    path: "/admin/viewtotalapplication",
    element: <ViewTotalApplication />,
  },

  {
    id: "addragistrationlink",
    path: "/admin/generateregistrationlink",
    element: <AddGenerateRegistrationLink />,
  },
  {
    id: "editragistrationlink",
    path: "/admin/editregistrationlink/:rowId",
    element: <EditGenerateRegistrationLink />,
  },

  {
    id: "learner",
    path: "/admin/learner",
    element: <Learner />,
  },
  {
    id: "addlearner",
    path: "/admin/addlearner",
    element: <AddLearner />,
  },
  {
    id: "editlearners",
    path: "/admin/editlearners/:rowId",
    element: <EditLearner />,
  },
  {
    id: "assignlearner",
    path: "/admin/assignlearner",
    element: <AssignLearner />,
  },
  {
    id: "assignlearner_2",
    path: "/admin/assignlearner/:selectedCource1/:selectedBatch1/:selectedCenter1",
    element: <AssignLearner />,
  },
  {
    id: "exam",
    path: "/admin/exam",
    element: <Exam />,
  },
  {
    id: "addexam",
    path: "/admin/addexam",
    element: <AddExam />,
  },
  {
    id: "editexam",
    path: "/admin/editexam/:rowId",
    element: <EditExam />,
  },
  {
    id: "examdashboard",
    path: "/admin/examdashboard/:rowId",
    element: <ExamDashboard />,
  },
  {
    id: "examresult",
    path: "/admin/examresult/:rowId",
    element: <ExamResult />,
  },
  {
    id: "addquestion",
    path: "/admin/addquestion/:rowId",
    element: <AddQuestionMain />,
  },
  {
    id: "addmarks",
    path: "/admin/addmarks/:rowId",
    element: <AddMarksMain />,
  },
  {
    id: "addmarks",
    path: "/admin/omr",
    element: <ViewOMR />,
  },
  {
    id: "addmarks",
    path: "/admin/omr/AddOmr",
    element: <AddOMR />,
  },
  {
    id: "scorescheme",
    path: "/admin/scorescheme",
    element: <ScoreScheme />,
  },
  {
    id: "addscorescheme",
    path: "/admin/addscorescheme",
    element: <AddScoreScheme />,
  },

  {
    id: "editscorescheme",
    path: "/admin/editscorescheme/:rowId",
    element: <EditScoreScheme />,
  },
];

export default BasicSixMonths;
